import { Grid2, Typography } from "@mui/material";
import cn from 'classnames';
import InnerLink from "../../InnerLink";
import { createCompanyLink } from "../../../pages";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import classes from './index.module.scss';

const CompanyRow = ({ company, showCompanyLink, onClick, isOpened = false }) => {
  return (
    <>
      <Grid2 size={showCompanyLink ? 11 : 12} className={cn(classes.row, classes.companyRow)} onClick={onClick}>
        {
          isOpened ? (
            <ArrowDropDownIcon size="small" className={classes.iconArrow} />
          ) : (
            <ArrowDropUpIcon size="small" className={classes.iconArrow} />
          )
        }
        <Typography variant="body2" className={classes.companyTitle}>{company.name}</Typography>
      </Grid2>
      {
        showCompanyLink ? (
          <Grid2 size={1} className={classes.row}>
            <InnerLink
              href={createCompanyLink(company.name)}
              noUnderline
              className={classes.link}
            >
              <Typography variant={'body2'} className={classes.typography}>
                <span>Company Area</span>
                <ArrowForwardIosIcon className={classes.icon} />
              </Typography>
            </InnerLink>
          </Grid2>
        ) : null
      }
    </>
  )
}

export default CompanyRow;